import { WebRTC } from "./webrtc";
import { SpeakableWebRTC } from "./speakable_webrtc";
import { CameraSpeakerAction, SpeakerWebrtcAction } from "../common/base";
import { AudioDevice } from "./audio_device";
export var MutedKind;
(function (MutedKind) {
    // acquired mic by other speaker
    MutedKind[MutedKind["Kicked"] = 1] = "Kicked";
    // close speaker by self
    MutedKind[MutedKind["Close"] = 2] = "Close";
    // webrtc closed
    MutedKind[MutedKind["WebrtcClose"] = 3] = "WebrtcClose";
    MutedKind[MutedKind["NotFound"] = 4] = "NotFound";
})(MutedKind || (MutedKind = {}));
export class AudioWebRTC extends SpeakableWebRTC {
    constructor(params, settings) {
        params.peerConfig = params.peerConfig || {};
        // TODO remove encodedInsertableStreams
        params.peerConfig["encodedInsertableStreams"] = true;
        super(params, settings);
        this.audioRtpSender = null;
        this.audioDevice = null;
        this.speakerRemoteOpened = false;
        this.addEventListener(WebRTC.EVENT_ACTION, (channel, msg) => {
            if (msg.act == AudioWebRTC.EVENT_SPEAKABLE) {
                this.setRemoteSpeakable(msg.data.speakable);
                if (this.isRemoteSpeakable()) {
                    this.openAudioDevice();
                }
                else {
                    this.closeDevice(MutedKind.Kicked);
                }
            }
        });
    }
    setRemoteSpeakable(speakable) {
        this.speakerRemoteOpened = speakable;
    }
    isRemoteSpeakable() {
        return this.speakerRemoteOpened;
    }
    doClose() {
        super.doClose();
        this.closeDevice(MutedKind.WebrtcClose);
    }
    configureMode() {
        this.peerConn.ontrack = (event) => {
            const streams = event.receiver.createEncodedStreams();
            streams.readable.pipeTo(streams.writable);
            const el = this.audio;
            el.srcObject = event.streams[0];
            el.autoplay = true;
        };
    }
    async onAnswer(audio, answer) {
        this.audio = audio;
        this.configureMode();
        await this.putAnswer(answer);
    }
    closeDevice(kind, err) {
        if (this.audioDevice === null) {
            return;
        }
        console.log("close audio device:", "kind=", kind.toString(), "connId=", this.connId);
        this.audioDevice.close();
        this.audioDevice = null;
        this.onSpeakableChange(kind, err);
    }
    onSpeakableChange(mutedKind, err) {
        this.emitEvent(AudioWebRTC.EVENT_SPEAKABLE, { speakMuted: !!mutedKind, kind: mutedKind, error: err });
    }
    closeAudioDevice() {
        this.closeDevice(MutedKind.Close);
    }
    cameraSpeakControl(params, callback) {
        const that = this;
        console.log("cameraSpeakControl", "macAddress=", params.macAddress, "connId=", this.connId);
        return this.sendActionMessage(CameraSpeakerAction.SPEAK, params, function (error, result) {
            if (error) {
                console.error("cameraSpeakControl error=", error, "macAddress=", params.macAddress, "connId=", that.connId);
                that.closeDevice(MutedKind.Close);
            }
            else {
                console.log("cameraSpeakControl result=", result);
                if (that.isRemoteSpeakable()) {
                    that.openAudioDevice();
                }
            }
            if (callback) {
                callback(error, result);
            }
        });
    }
    speakerSpeakControl(params, callback) {
        const that = this;
        console.log("speakerSpeakControl", "macAddress=", params.macAddress, "connId=", this.connId);
        return this.sendActionMessage(SpeakerWebrtcAction.SPEAK, params, function (error, result) {
            if (error) {
                console.error("speakerSpeakControl error=", error, "macAddress=", params.macAddress, "connId=", that.connId);
                that.closeDevice(MutedKind.Close);
            }
            else {
                console.log("speakerSpeakControl result=", result);
                if (that.isRemoteSpeakable()) {
                    that.openAudioDevice();
                }
            }
            if (callback) {
                callback(error, result);
            }
        });
    }
    getAudioRtpSender() {
        if (this.audioRtpSender === null) {
            const sender = this.peerConn.getTransceivers()[1].sender;
            const streams = sender.createEncodedStreams();
            streams.readable.pipeTo(streams.writable);
            this.audioRtpSender = sender;
        }
        return this.audioRtpSender;
    }
    openAudioDevice() {
        if (this.audioDevice) {
            return;
        }
        this.audioDevice = new AudioDevice();
        const that = this;
        this.audioDevice.open(this.getAudioRtpSender(), function (opened, err) {
            if (opened) {
                that.onSpeakableChange();
            }
            else {
                that.closeDevice(MutedKind.Close, err);
            }
        });
    }
    enableAudioOutput(enabled) {
        if (this.audio)
            this.audio.muted = enabled;
    }
}
// actions
AudioWebRTC.EVENT_SPEAKABLE = 'speaker.speakable';
